import { createApiCall } from 'lib/base';

interface LoginBody {
  email: string;
  password: string;
}

const LOGIN = 'LOGIN';

export const loginApi = createApiCall<LoginBody>(LOGIN, body => ({
  endpoint: `api/admin/auth/login`,
  method: 'POST',
  body: JSON.stringify(body),
  skipDefaultErrorHandling: true,
}));

export default loginApi;
